import { call, put, takeEvery } from 'redux-saga/effects';
import {
  betEditRequest,
  betsRequest,
  createBet,
  createBetBatch,
  ownedBetsRequest,
  BatchResult,
} from '../../api/bets';
import { betsActions, BatchCreatePayload } from '../../store/bets/actions';
import {
  BET_EDIT_FAILURE,
  BET_EDIT_REQUEST,
  BET_EDIT_SUCCESS,
  BETS_REQUEST,
  CREATE_BET_REQUEST,
  CREATE_BET_BATCH_REQUEST,
} from '../../constants/bets';
import { toast } from 'react-toastify';
import { ownedBetsActions } from '../../store/ownedBets/actions';
import { OWNED_BETS_REQUEST } from '../../constants/ownedBets';
import { push } from 'connected-react-router';
//interfaces
import { SagasAction } from '../interfaces';
//Tr
import i18n from '../../i18n';

import { CustomToast } from '../../utils/errorHandling/CustomToast';

function* betsRequestSaga(action: any): any {
  try {
    const bets = yield call(betsRequest, action.payload);
    yield put(betsActions.betsSuccessAction(bets));
  } catch (e: any) {
    yield put(betsActions.betsFailureAction(e));
  }
}
function* ownedBetsRequestSaga(openstatus: any): any {
  try {
    const bets = yield call(ownedBetsRequest, openstatus);
    yield put(ownedBetsActions.ownedBetsSuccessAction(bets, openstatus));
  } catch (e: any) {
    toast.error(i18n.t('translation:owned-bets_error'));
    yield put(ownedBetsActions.ownedBetsFailureAction(e));
  }
}

function* betEditFailureSaga() {
  toast.error(i18n.t('translation:correct-tip_error'));
  yield put(push('/my-bets'));
}
function* betEditSuccessSaga() {
  yield toast.success(i18n.t('translation:correct-tip_success'));
  yield put(push('/my-bets'));
}

function* betEditRequestSaga(action: any): any {
  try {
    const bets = yield call(betEditRequest, action.payload);
    if (!bets) {
      yield put(betsActions.betEditFailureAction('e'));
    } else {
      yield put(betsActions.betEditSuccessAction(bets));
    }
  } catch (e: any) {}
}

function* createBetRequestSaga({
  payload,
}: SagasAction): Generator<any, any, any> {
  try {
    const createdBet = yield call(createBet, payload);
    if (createdBet && createdBet.tip) {
      yield put(betsActions.createBetSuccessAction(createdBet.tip.id));
      toast.success(i18n.t('translation:publish-tip_success'));
      yield put(push('/my-bets'));
    }
  } catch (e: any) {
    if (e.detail) {
      toast.error(
        CustomToast(
          i18n.t('translation:publish-tip_error'),
          i18n.t(`translation:${e.type}`),
        ),
      );
    } else {
      toast.error(
        CustomToast(i18n.t('translation:publish-tip_error'), e.message),
      );
    }

    yield put(betsActions.createBetFailureAction(e));
  }
}

// Batch create saga for multi-channel publishing
function* createBetBatchRequestSaga({
  payload,
}: {
  type: string;
  payload: BatchCreatePayload;
}): Generator<any, any, any> {
  try {
    const { formData, channelIds } = payload;
    const results: BatchResult[] = yield call(createBetBatch, formData, channelIds);

    const successResults = results.filter((r) => r.success);
    const failedResults = results.filter((r) => !r.success);

    if (successResults.length === results.length) {
      // All succeeded
      yield put(
        betsActions.createBetBatchSuccessAction({
          count: successResults.length,
          tipIds: successResults.map((r) => r.tip_id!).filter(Boolean),
        }),
      );
      toast.success(
        i18n.t('translation:publish-tip-batch_success', {
          count: successResults.length,
        }),
      );
      // Clear sessionStorage
      sessionStorage.removeItem('selectedChannels');
      yield put(push('/my-bets'));
    } else if (successResults.length > 0) {
      // Partial success
      yield put(
        betsActions.createBetBatchPartialAction({
          success: successResults.length,
          failed: failedResults.length,
        }),
      );
      toast.warn(
        CustomToast(
          i18n.t('translation:publish-tip-batch_partial', {
            success: successResults.length,
            failed: failedResults.length,
          }),
          failedResults.map((r) => r.error).join(', '),
        ),
      );
      // Clear sessionStorage
      sessionStorage.removeItem('selectedChannels');
      yield put(push('/my-bets'));
    } else {
      // All failed
      yield put(betsActions.createBetBatchFailureAction(failedResults));
      toast.error(
        CustomToast(
          i18n.t('translation:publish-tip-batch_error'),
          failedResults.map((r) => r.error).join(', '),
        ),
      );
    }
  } catch (e: any) {
    toast.error(
      CustomToast(i18n.t('translation:publish-tip-batch_error'), e.message),
    );
    yield put(betsActions.createBetBatchFailureAction(e));
  }
}

function* betsSaga() {
  yield takeEvery(BETS_REQUEST, betsRequestSaga);
  yield takeEvery(OWNED_BETS_REQUEST, ownedBetsRequestSaga);
  yield takeEvery(BET_EDIT_FAILURE, betEditFailureSaga);
  yield takeEvery(BET_EDIT_SUCCESS, betEditSuccessSaga);
  yield takeEvery(BET_EDIT_REQUEST, betEditRequestSaga);
  yield takeEvery(CREATE_BET_REQUEST, createBetRequestSaga);
  yield takeEvery(CREATE_BET_BATCH_REQUEST, createBetBatchRequestSaga);
}

export default betsSaga;
